<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    @click:outside="$emit('close')"
  >
    <v-card dark>
      <v-card-title class="headline grey darken-3 d-flex justify-space-between">
        <span class="text-h6">Post Comments ({{ comments.length }})</span>
        <v-btn
          icon
          dark
          @click="$emit('close')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-simple-table dense fixed-header height="450px" v-if="comments && comments.length > 0">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Commenter</th>
                <th class="text-left" style="min-width: 120px;">Date</th>
                <th class="text-left">Comment</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(comment, index) in comments"
                :key="index"
              >
                <td>
                  <a :href="comment.comment_user_url" target="_blank" v-if="comment.comment_user_url">@{{ comment.comment_user }}</a>
                  <span v-else>@{{ comment.comment_user }}</span>
                </td>
                <td>{{ comment.comment_date | dateFormat }}</td>
                <td>{{ comment.comment }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div v-else class="text-center pa-5">
          No comments found for this post.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="$emit('close')">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import moment from 'moment';

export default {
  props: {
    // Controls dialog visibility
    value: {
      type: Boolean,
      default: false,
    },
    // The array of comments to display
    comments: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        if (!val) {
          // Emit 'close' when v-model changes (e.g., when clicking the 'x' button or backdrop)
          this.$emit('close'); 
        }
      },
    },
  },
  filters: {
    // Filter to format the date using Moment.js
    dateFormat(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).format('DD-MM-YYYY');
    },
  },
};
</script>



// WEBPACK FOOTER //
// ViewPostCommentsModal.vue?0985d470